import STAFF_DATA from '@/src/router/views/staff/staff.json'
import GRAPH_CONSTANTS from '@src/constants/graph-constants.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants'

export const rightBarStats = () => {
  const stats = [
    {
      title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
    },
  ]
  return stats
}

export const staffGraphChart = (BAR_GRAPH_VALUE, PIE_GRAPH_VALUE) => {
  const chartData = [
    GRAPH_CONSTANTS.BAR_CHART(
      STAFF_DATA.BAR_LABELS,
      BAR_GRAPH_VALUE,
      STAFF_DATA.BAR_TITLE,
      STAFF_DATA.BAR_LABELS_STRING,
    ),
    GRAPH_CONSTANTS.PIE_CHART(
      STAFF_DATA.PIE_LABELS,
      PIE_GRAPH_VALUE,
      STAFF_DATA.PIE_BACKGROUND_COLOR,
      STAFF_DATA.PIE_TITLE,
    ),
  ]
  return chartData
}
